import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InViewportModule } from 'ng-in-viewport';

import { TrackingModule } from 'src/app/core/services/tracking/tracking.module';
import { FootnotesModule } from 'src/app/shared/footnotes/footnotes.module';
import { ImagesModule } from 'src/app/shared/images/image/images.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { ShowPriceModule } from 'src/app/shared/show-price/show-price.module';

import { EnvironmentalBonusModule } from '../environmental-bonus/environmental-bonus.module';
import { RecommendationLabelModule } from '../recommendation-label/recommendation-label.module';
import { SimsearchViewComponent } from './simsearch-view/simsearch-view.component';
import { SimsearchService } from './simsearch.service';
import { SimsearchTrackingEffects } from './store/simsearch-tracking.effects';
import { SimsearchEffects } from './store/simsearch.effects';
import { simsearchReducer } from './store/simsearch.reducer';

@NgModule({
  imports: [
    CommonModule,
    ImagesModule,
    PipesModule,
    FootnotesModule,
    StoreModule.forFeature('simsearch', simsearchReducer),
    EffectsModule.forFeature([SimsearchEffects, SimsearchTrackingEffects]),
    TrackingModule,
    RecommendationLabelModule,
    InViewportModule,
    ShowPriceModule,
    EnvironmentalBonusModule
  ],
  providers: [SimsearchService],
  declarations: [SimsearchViewComponent],
  exports: [SimsearchViewComponent],
  bootstrap: [SimsearchViewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SimsearchModule {
  public static readonly rootComponent = SimsearchViewComponent;
}
